import { createFileRoute } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import DraftCables from 'pages/DraftCables'
import DraftCablesClassic from 'pages/DraftCables/DraftCables.classic'

const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/drafts')({
  component: IS_CLASSIC_UI ? DraftCablesClassic : DraftCables,
})
